module.exports = __webpack_public_path__ + "img/style_1_en.cefd5f08.jpeg";